import uniqBy from 'lodash/uniqBy';

import { isMaestroActionTask, isMaestroTransportTask } from './helpers';
import { addLevelsToTasks } from './utils';
import {
  MaestroHistoricTaskProgress,
  RunLabware,
  TaskLabware,
} from '../../../types';

export const createRunProgressLabwareCentric = (
  runProgressTasks: MaestroHistoricTaskProgress[]
): RunLabware => {
  const runLabware: RunLabware = {};

  const isBatched = runProgressTasks.some((t) => {
    if (isMaestroTransportTask(t.task)) {
      return (t.task.labware.batch ?? 1) > 1;
    } else if (
      isMaestroActionTask(t.task) &&
      t.task.labware_in.some((l) => (l.batch ?? 1) > 1)
    ) {
      return true;
    } else {
      return false;
    }
  });

  const updateLabwareTasks = (
    labware: TaskLabware,
    taskProgress: MaestroHistoricTaskProgress
  ) => {
    const labwareId = labware.id;
    const label =
      labware.description.length > 0 ? labware.description : labware.label;
    runLabware[labwareId] = {
      ...labware,
      label: isBatched ? `${label} ${labware.batch}` : label,
      tasks: [...(runLabware[labwareId]?.tasks || []), taskProgress],
      batch: labware.batch,
    };
  };

  runProgressTasks.forEach((taskProgress) => {
    if (isMaestroTransportTask(taskProgress.task)) {
      updateLabwareTasks(taskProgress.task.labware, taskProgress);
    }

    if (isMaestroActionTask(taskProgress.task)) {
      uniqBy(
        [...taskProgress.task.labware_in, ...taskProgress.task.labware_out],
        'id'
      ).forEach((labware) => {
        updateLabwareTasks(labware, taskProgress);
      });
    }
  });

  return addLevelsToTasks(runLabware);
};
